/* eslint-disable @typescript-eslint/no-explicit-any */
export const getBrowserLocale = () => {
    const { languages } = navigator;
    const locale = languages && languages.length ? languages[0]
        : (((navigator as any).userLanguage || navigator.language || (navigator as any).browserLanguage) as string);

    return locale || undefined;
  }
